import React, { useCallback } from 'react';

import '../css/PaymentHistoryDetailsRow.css';
import { currencyFormat } from '../../../../services/utils';

const PaymentHistoryDetailsRow = ({
  amountValue = '',
  detailsValue = [],
  totalTitle = '',
}) => {
  const formattedValue = useCallback((value) => currencyFormat({
    value: value?.toString().replace('$', '') || 0,
  }), []);

  function renderTotalRow() {
    return (
      <tr className="Payment-history-details-row-total">
        <td className="Payment-history-details-total-value">
          <span>{totalTitle}</span>

          <span>{amountValue}</span>
        </td>
      </tr>
    );
  }

  return (
    <>
      {detailsValue.map((detail) => (
        <tr
          key={String(detail.Description)}
          className="Payment-history-details-row"
        >
          <td className="Payment-history-details-value">
            <span>{detail.Description}</span>

            <span>{formattedValue(detail.Amount)}</span>
          </td>
        </tr>
      ))}

      {renderTotalRow()}
    </>
  );
};

export { PaymentHistoryDetailsRow };
